import store from '../store/index'
import { Message } from "view-design"
import Vue from 'vue'
import router from "@/router";

export const proName = 'yuedu'
export const getUrlCode = (codeName) => {
  const isHave = window.location.search.split(codeName)[1]
  const codeValue = isHave ? isHave.split('&')[0].replace(/=/g, '') : ''
  return codeValue
}
export const getOrgCode = () => {
  return window.location.pathname.split('/')[2] || 'super'
}
export const getAxiosUrl = (whichPost) => {
  // let baseurl = 'http://dsyjapi.readerstar.net'
  let baseurl = 'http://dsyj2025api.readerstar.cn'
  // const isTest = window.location.href.includes('.cn') || window.location.href.includes(':808')
  const isProduction = window.location.href.includes('.cn')
  switch (whichPost) {
    // 超级管理员
    case 'admin':
      if (isProduction) {
        baseurl = 'https://dsyj2025api.readerstar.cn'
      }
      break
    // 其他
    default:
      baseurl = whichPost
      break
  }
  return baseurl
}
// 添加token
export const backendTokenSet = (data) => {
  if (!data) { return false }
  localStorage.setItem(`${proName}Token`, data)
}
export const backendTokenGet = () => {
  return localStorage.getItem(`${proName}Token`)
}
export const backendTokenRemove = (id) => {
  localStorage.setItem(`${proName}Token`, '')
  localStorage.setItem(`userInfo`, '')
  Vue.$router.push('/')
}
// 确认弹窗
export const confirm = async (title, content, okFn, type, cancelFn) => {
  const ourTitle = title || '提示'
  const ourContent = content || '您确定执行当前操作吗？'
  Vue.prototype.$Modal.confirm({
    // title: title || ourTitle,
    render: (h, params) => {
      return (
        <div>
          <div class="ivu-modal-confirm-head-icon ivu-modal-confirm-head-icon-confirm">
            { ourTitle === '警告'
              ? <i class="ivu-icon ivu-icon-md-warning"></i>
              : <i class="ivu-icon ivu-icon-ios-help-circle"></i>
            }
          </div>
          <div class="ivu-modal-confirm-head-title">{ourTitle}</div>
          <div class="ivu-modal-confirm-body"><div>{ourContent}</div></div>
        </div>
      )
    },
    onOk: () => {
      setTimeout(() => {
        if (okFn) {
          okFn()
        } else {
          return 0
        }
      }, 300)
    },
    onCancel: () => {
      setTimeout(() => {
        if (cancelFn) {
          cancelFn()
        } else {
          return 0
        }
      }, 300)
    }
  })
}
export const onlyOkConfirm = async (title, content, okFn) => {
  const ourTitle = title || '提示'
  const ourContent = content || '您确定执行当前操作吗？'
  Vue.prototype.$Modal.success({
    // title: title || ourTitle,
    render: (h, params) => {
      return (
        <div>
          <div class="ivu-modal-confirm-head-icon ivu-modal-confirm-head-icon-success">
            { ourTitle === '警告'
              ? <i class="ivu-icon ivu-icon-md-warning"></i>
              : <i class="ivu-icon ivu-icon-ios-checkmark-circle"></i>
            }
          </div>
          <div class="ivu-modal-confirm-head-title" domPropsInnerHTML={ourTitle}></div>
          <div class="ivu-modal-confirm-body"><div domPropsInnerHTML={ourContent}></div></div>
        </div>
      )
    },
    cancelText: '',
    onOk: async () => {
      if (okFn) {
        await okFn()
      } else {
        const res = await 0
        return res
      }
    }
  })
}
// 对接口进行处理
export const handleRes = (data, successInfo, successFn, errorInfo, errorFn) => {
  let ourData
  if (data.code === 200) {
    if (successFn) {
      ourData = successFn()
    }
    if (successInfo && successInfo !== '') { backMessage(true, successInfo) }
  } else if (data.code !== 200) {
    if (errorFn) {
      ourData = errorFn()
    }
    if (data.code === 0) {
      backMessage('', '视频正在云端转换，请稍候在访问该视频')
    } else if (data.code !== 404 && data.message && data.message !== 'OK') {
      backMessage(false, data.message)
      if (data.message === '机构不存在') {
        // 重定向
        // Vue.$router.replace('/error404')
      }
    } else {
      backMessage(false, errorInfo)
    }
  }
  return ourData
}
// 报错弹窗
export const backMessage = (type, content, time) => {
  type = type || false
  if (type === false) {
    content = content || '请求失败,请稍候再试'
    Vue.prototype.$Modal.error({
      title: '错误',
      content: content
    })
  } else if (type === 'warning') {
    content = content || '请求失败,请稍候再试'
    Vue.prototype.$Modal.warning({
      title: '错误',
      content: content
    })
  } else {
    Vue.prototype.$Message.success({
      content: content,
      duration: time
    })
  }
}
// 获取改变页面title
export const changeWebTitle = (name, reflesh) => {
  if (name && !reflesh) {
    document.title = `${document.title}-${name}`
  } else if (name && reflesh) {
    document.title = `${name}`
  }
}
// 没有权限的弹框
export const noAuthority = (title, urlName) => {
  Vue.prototype.$Modal.error({
    title: '错误',
    content: title,
    onOk: () => {
      if (backendTokenGet()) {
        if (urlName) {
          Vue.$router.push(`/${getOrgCode()}/${urlName}`)
        } else {
          // @TODO 跳转逻辑更改
          Vue.$router.replace('/')
          // Vue.$router.push(`/${getOrgCode()}/functionIndex`)
        }
      } else {
        // @TODO 跳转登录
        // Vue.$router.push(`/${getOrgCode()}/login`)
        Vue.$router.replace('/')
        // window.location.href = `${window.location.protocol}//${window.location.hostname}`
      }
    }
  })
}
// 处理页面列表页面是否有权限
export const handleResAuthor = (code, message) => {
  switch (code) {
    case 10003:
      message = '未登录或登录过期，请重新登录'
      Message.error(message)
      break
    case 500:
      message = '服务器未响应，请稍后再试'
      Message.error(message)
      store.dispatch('showPageAuthor', 0)
      break
    case 401:
      message = '当前页面没有权限'
      Message.error(message)
      store.dispatch('showPageAuthor', 2)
      clearUserInfo()
      break
    case 10002:
      message = '当前页面没有权限'
      Message.error(message)
      store.dispatch('showPageAuthor', 2)
      clearUserInfo()
      break
    case 200:
      store.dispatch('showPageAuthor', 1)
      break
    default:
      store.dispatch('showPageAuthor', 1)
      break
  }
}
export const isHaveToken = () => {
  if (!backendTokenGet()) {
    // @TODO 更改入口
    // Vue.$router.push(`/${this.a.getWhichOrg()}/login`)
    return false
  } else {
    return true
  }
}

// 删除掉两个播放键
export const removeAplayerButton = (elements) => {
  if (elements) {
    elements.$el.children[0].children[1].children[1].children[1].children[2].style.display = 'none'
    elements.$el.children[0].children[1].children[1].children[1].children[3].style.display = 'none'
  }
}
export const setCookie = (name, token) => {
  Vue.prototype.$cookie.set(name, token, { expires: 1 })
}
export const getCookie = (name) => {
  return Vue.prototype.$cookie.get(name)
}
export const removeCookie = (name) => {
  Vue.prototype.$cookie.remove(name)
}
export const clearUserInfo = () => {
  removeCookie('readStar')
  removeCookie('level')
  removeCookie('id')
  router.replace('/')
}
// 活动报名时间,因无确定时间先放开至8月
export const ISEND = new Date() < new Date('2022-11-7 23:59:59')
// 活动推选时间
// export const RECEND = new Date() < new Date('2021-08-10 23:59:59')
export const RECEND = true
